import { IPerson } from './iperson';

export interface IPersonState {
    person: IPerson,
    persons: IPerson[],
    error?: any
}
